import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { TextV1Attributes } from '@/features/text-v1/text-v1-type';

import React from 'react';

import { HtmlTextWrapper } from '@/core/features';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';

export type TextV1Props = React.PropsWithChildren<PageComponentProps<TextV1Attributes>>;

// children prop is needed to render the show more button in a group component
export default function TextV1({ attributes, children, groupComponentProps }: TextV1Props) {
    const { displayStyle, htmlText } = attributes;
    const { isDesktopView } = useDeviceoutput();
    const hasContentBox = displayStyle === null && !groupComponentProps?.hasContentBox && !isDesktopView;

    return (
        <div
            className={
                !hasContentBox
                    ? `textV1Wrapper block ${!!displayStyle ? 'text-center font-size-14 text-dove-gray' : ''}`
                    : ''
            }
        >
            <HtmlTextWrapper
                className={isDesktopView ? 'font-size-16' : ''}
                htmlText={htmlText}
                style={{ lineHeight: isDesktopView ? '21px' : undefined }}
            />
            {children}
            <style
                global
                jsx
            >{`
                .textV1Wrapper ul {
                    line-height: 24px;
                }
            `}</style>
        </div>
    );
}
